import { Component, Input } from '@angular/core';

@Component({
    selector: '[tna-money]',
    templateUrl: './money.component.html',
    standalone: false
})
export class MoneyComponent {
  @Input()
  public amount;

  @Input()
  public alignRight = true;
}
